// Module
var code = "<div class=\"actionItemsTooltip\"> <!-- ko foreach: $_data.ActionItems --> <div class=\"actionItemsTooltip__item\"> <span class=\"name\"> <!--ko text: NameTranslation || Name --><!--/ko--> </span> </div> <!-- /ko --> </div>";
// Exports
export default code;